// extracted by mini-css-extract-plugin
module.exports = {"replacementsContainer":"ProductIngredientsForm_replacementsContainer__RFibJ"};